import { render, staticRenderFns } from "./IdleLeadsReport.vue?vue&type=template&id=4fbddcf6&scoped=true"
import script from "./IdleLeadsReport.vue?vue&type=script&lang=js"
export * from "./IdleLeadsReport.vue?vue&type=script&lang=js"
import style0 from "./IdleLeadsReport.vue?vue&type=style&index=0&id=4fbddcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbddcf6",
  null
  
)

export default component.exports